export const saveFileInfo = async (fileInfo) => {
  try {
    localStorage.setItem("file_info", JSON.stringify(fileInfo));
  } catch (err) {}
};

export const getFileInfo = async () => {
  try {
    const data = localStorage.getItem("file_info");
    return data ? JSON.parse(data) : null;
  } catch (err) {
    return null;
  }
};

export const clearFileInfo = async () => {
  try {
    localStorage.removeItem("file_info");
  } catch (err) {}
};

// User-specific chat history
export const saveUserHistory = (userId, history) => {
  if (!userId) return;
  localStorage.setItem(`history_${userId}`, JSON.stringify(history));
};

export const getUserHistory = (userId) => {
  if (!userId) return [];
  const data = localStorage.getItem(`history_${userId}`);
  return data ? JSON.parse(data) : [];
};

export const clearUserHistory = (userId) => {
  if (!userId) return;
  localStorage.removeItem(`history_${userId}`);
};

// Session-file mapping per user
export const saveSessionFileInfo = (userId, sessionId, fileInfo) => {
  if (!userId || !sessionId) return;
  localStorage.setItem(
    `session_file_${userId}_${sessionId}`,
    JSON.stringify(fileInfo)
  );
};

export const getSessionFileInfo = (userId, sessionId) => {
  if (!userId || !sessionId) return null;
  const data = localStorage.getItem(`session_file_${userId}_${sessionId}`);
  return data ? JSON.parse(data) : null;
};

export const clearSessionFiles = (userId) => {
  if (!userId) return;
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith(`session_file_${userId}_`)) {
      localStorage.removeItem(key);
    }
  });
};
